import { AxiosPromise } from 'axios';

import { api } from '.';

export const resetPassword = (email: string): AxiosPromise =>
  api.post('auth/reset-password', { email });
